<script setup lang="ts">
import { ref, onMounted } from 'vue';

const visible = ref(false);
const isAppeared = ref(false);

onMounted(() => {
  setTimeout(() => {
    visible.value = true;
    setTimeout(() => {
      isAppeared.value = true;
    }, 600);
  }, 800);
});
</script>

<template>
  <div class="success-overlay">
    <div class="success-message">
      <h1>Formularz został przesłany!</h1>
    </div>
    <div v-if="visible" class="checkmark" :class="{ appear: isAppeared }">
      ✔️
    </div>
    <div v-else class="checkmark"></div>
    <a href="https://wspomnieniazwesela.pl/" class="success-button"
      >Powrót do strony głównej</a
    >
  </div>
</template>

<style lang="scss" scoped>
.success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $white-200;
  align-items: center;
  z-index: 9999;
  color: #fff;
  font-family: Arial, sans-serif;
  justify-content: center;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  gap: 15px;

  .success-message {
    text-align: center;
    color: #008604;

    h1 {
      font-size: 2.5em;
      line-height: 1em;
      font-weight: bold;
    }
  }

  .success-button {
    font-size: 1.5em;
    font-weight: 700;
    border-radius: 14px;
    border: 2px solid $brown-200;
    padding: 10px 25px;
    cursor: pointer;
    transition: ease 0.7s all;
    color: $brown-200;
    margin-top: 50px;
    text-align: center;

    &:hover {
      background-color: $brown-200;
      color: $white-100;
    }
  }
}

.checkmark {
  font-size: 3em;
  opacity: 0;
  transform: translateY(-20px);
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
  width: 70px;
  height: 70px;

  &.appear {
    opacity: 1;
    transform: translateY(0);
  }
}

.checkmark[v-cloak] {
  display: none;
}
</style>
